// import fs from 'fs';
// import { pathDirname } from 'shared/utils/desktop/path';

// TODO: Remove all sync fs methods

export class Stats {}
export const fsEnsureDirSync = () => {
	throw new Error('"fsEnsureDirSync" is not accessible in web application');
};
export const fsLstatSync = () => {
	throw new Error('"fsLstatSync" is not accessible in web application');
};
export const fsExists = async () => {
	throw new Error('"fsExists" is not accessible in web application');
};
export const fsLstat = async () => {
	throw new Error('"fsLstat" is not accessible in web application');
};
export const fsReaddir = async () => {
	throw new Error('"fsReaddir" is not accessible in web application');
};
export const fsRemoveSync = (path) => {
	throw new Error('"fsReaddir" is not accessible in web application');
};

//
// ////////
//
// export const TEMPORARY_FILE_EXTENSION = '.tiv_temp';
// export const TEMPORARY_FILE_EXTENSION_FILTER = new RegExp(`\\${TEMPORARY_FILE_EXTENSION}$`);
// export const TEMPORARY_FILE_EXTENSION_FILTER_OLD = /\.meedi_temp/;
//
// export const fsFstatSync = fs.fstatSync;
//
// export const fsReaddirSync = fs.readdirSync;
//
// export const fsExistsSync = fs.existsSync;
//
// export const fsOpen = fs.promises.open;
// export const fsOpenSync = fs.openSync;
//
// export const fsClose = async fileHandle => fileHandle?.close();
// export const fsCloseSync = fs.closeSync;
//
// export const fsReadSync = fs.readSync;
//
// export const fsEnsureDir = async (path, options = { recursive: true }) => fs.promises.mkdir(path, options);
//
// export const fsRenameSync = fs.renameSync;
//
// export const fsRemove = (path) => {
//   return fs.promises.rm(path, {
//     force: true,
//     recursive: true
//   });
// }
//
//
// const fs_move = async (oldPath, newPath) => {
//   await fsEnsureDir(pathDirname(newPath));
//
//   try {
//     await fs.promises.rename(oldPath, newPath);
//   } catch (err) {
//     if (err.code === 'EXDEV') {
//       await fs.promises.copyFile(oldPath, newPath);
//       await fs.promises.unlink(oldPath);
//       return;
//     }
//     throw err;
//   }
// }
// const fs_move_sync = (oldPath, newPath) => {
//   fsEnsureDirSync(pathDirname(newPath));
//
//   fs.rename(oldPath, newPath, function (err) {
//     if (err) {
//       if (err.code === 'EXDEV') {
//         fs.copyFileSync(oldPath, newPath);
//         fs.unlink(oldPath);
//         return;
//       }
//       throw err;
//     }
//   });
// }
//
// const doMove = async (src, dest) => {
//     try {
//         await fs_move(src, dest);
//     } catch (e) {
//         if (await fsExists(src)) {
//             if (!(await fsExists(dest))) {
//                 throw e;
//             } else {
//                 console.error(`Two file versions are present at once: "${src}" and "${dest}".`);
//             }
//         } else if (!await fsExists(dest)) {
//             console.error(`Can not find none of these files: "${src}" and "${dest}".`);
//         } else {
//             // move file back
//             await fs_move(dest, src);
//         }
//         throw e;
//     }
// };
// export const fsMove = async (src, dest) => {
//     if (TEMPORARY_FILE_EXTENSION_FILTER.test(src) || TEMPORARY_FILE_EXTENSION_FILTER.test(dest)) {
//         await doMove(src, dest);
//         return;
//     }
//
//     const tempDest = `${dest}${TEMPORARY_FILE_EXTENSION}`;
//     await doMove(src, tempDest);
//
//     if (!(await fsExists(src)) && await fsExists(tempDest)) {
//         await doMove(tempDest, dest);
//     }
// };
// export const fsMoveSync = fs_move_sync;
//
// export const fsCopy = async (src, dest) => {
//   await fsEnsureDir(pathDirname(dest));
//
//     const tempDest = `${dest}${TEMPORARY_FILE_EXTENSION}`;
//     await fsRemove(tempDest);
//
//     try {
//         await fs.promises.copyFile(src, tempDest);
//         await fsMove(tempDest, dest);
//     } finally {
//         await fsRemove(tempDest);
//     }
// };
//
// export const fsCreateReadStream = fs.createReadStream;
